import { useMemo } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";

import type { IURLFilterState } from "../types";

export const useSourcesUrlParams = (): IURLFilterState => {
    const {
        params: { searchTerm, domainFilter, changeFilter },
    } = useCurrentStateAndParams();

    return useMemo<IURLFilterState>(
        () => ({
            ...(searchTerm ? { searchTerm: searchTerm as string } : {}),
            ...(domainFilter ? { domainFilter: domainFilter as string } : {}),
            ...(changeFilter ? { changeFilter: (changeFilter as string).split(",") } : {}),
        }),
        [searchTerm, domainFilter, changeFilter],
    );
};
